var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPypi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pypi_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F4",
  d: "m4.221 9.737 3.094 1.134 3.14-1.15-3.094-1.135-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M7.39 8.508h-.057l-3.14 1.15v.157l3.094 1.134h.057l3.14-1.15V9.64L7.39 8.508Zm-.029.167 2.852 1.045-2.898 1.062-2.85-1.046L7.36 8.675Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEEEA",
  d: "m4.221 9.737 3.094 1.134v3.661l-3.094-1.134V9.737Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m4.25 9.658-.112.079v3.662l.055.078 3.094 1.134.111-.079v-3.661l-.054-.079L4.25 9.658Zm.054.198 2.928 1.073v3.484L4.304 13.34V9.856Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F4",
  d: "m7.33 7.177 3.093 1.134 3.14-1.151-3.094-1.134-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M10.498 5.948h-.057l-3.14 1.15v.158l3.094 1.133h.057l3.14-1.15v-.157l-3.094-1.134Zm-.029.167 2.852 1.045-2.898 1.062-2.851-1.045 2.897-1.062Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEEEA",
  d: "m7.33 7.177 3.093 1.134v3.661L7.33 10.84V7.176Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m7.358 7.098-.111.079v3.661l.054.079 3.094 1.134.112-.079V8.311l-.055-.079-3.094-1.134Zm.054.198 2.929 1.073v3.484L7.412 10.78V7.296Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F4",
  d: "m1.114 14.572 3.094 1.134 3.14-1.15-3.094-1.134-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M4.283 13.344h-.057l-3.14 1.15v.157l3.094 1.134h.057l3.14-1.15v-.158l-3.094-1.133Zm-.029.167 2.852 1.045-2.898 1.062-2.851-1.045 2.897-1.062Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEEEA",
  d: "m1.114 14.572 3.094 1.134v3.662l-3.094-1.134v-3.662Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m1.143 14.494-.112.079v3.661l.055.078 3.094 1.134.111-.078v-3.662l-.054-.078-3.094-1.134Zm.054.198 2.928 1.073v3.483l-2.928-1.073v-3.483Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEEEA",
  d: "m4.221 15.71 3.094 1.134v3.662l-3.094-1.134V15.71Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m4.25 15.632-.112.078v3.662l.055.078 3.094 1.134.111-.078v-3.662l-.054-.078-3.094-1.134Zm.054.197 2.928 1.074v3.483l-2.928-1.073V15.83Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F4",
  d: "m4.221 12.013 3.094 1.133 3.14-1.15-3.094-1.134-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M7.39 10.784h-.057l-3.14 1.15v.157l3.094 1.134h.057l3.14-1.15v-.157L7.39 10.784Zm-.029.167 2.852 1.045-2.898 1.062-2.85-1.045L7.36 10.95Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEEEA",
  d: "m4.221 12.013 3.094 1.133v3.662l-3.094-1.134v-3.661Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m4.25 11.934-.112.079v3.661l.055.079 3.094 1.133.111-.078v-3.662l-.054-.078-3.094-1.134Zm.054.198 2.928 1.073v3.483l-2.928-1.073v-3.483Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.746 14.569v3.661l3.14-1.15v-3.662l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m22.857 13.34-3.14 1.15-.054.079v3.661l.111.079 3.14-1.151.055-.079v-3.661l-.112-.079Zm-.055.197v3.484l-2.973 1.09v-3.484l2.973-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD242",
  d: "M16.638 15.706v3.662l3.14-1.15v-3.662l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m19.75 14.477-3.14 1.15-.055.08v3.66l.111.08 3.14-1.151.055-.079v-3.661l-.111-.079Zm-.055.198v3.484l-2.974 1.09v-3.484l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD242",
  d: "M13.53 16.844v3.662l3.14-1.15v-3.662l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m16.642 15.615-3.14 1.15-.054.079v3.662l.111.078 3.14-1.15.055-.08v-3.66l-.112-.08Zm-.054.197v3.484l-2.974 1.09v-3.483l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.423 17.982v3.661l3.14-1.15V16.83l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m13.535 16.753-3.14 1.15-.055.079v3.661l.112.079 3.14-1.15.054-.08v-3.66l-.111-.08Zm-.055.197v3.484l-2.974 1.09V18.04l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEEEA",
  d: "m7.33 16.848 3.093 1.134v3.662L7.33 20.51v-3.662Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m7.358 16.77-.111.078v3.662l.054.078 3.094 1.134.112-.079v-3.661l-.055-.079-3.094-1.133Zm.054.197 2.929 1.073v3.484l-2.929-1.073v-3.484Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD242",
  d: "M19.746 10.87v3.662l3.14-1.15V9.72l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m22.857 9.642-3.14 1.15-.054.079v3.662l.111.078 3.14-1.15.055-.08v-3.66l-.112-.08Zm-.055.197v3.484l-2.973 1.09V10.93l2.973-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353564",
  d: "M16.652 6.04V9.7l3.14-1.15V4.89l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m19.763 4.81-3.14 1.15-.054.08V9.7l.111.08 3.14-1.152.055-.078V4.888l-.112-.078Zm-.054.197v3.484l-2.974 1.09V6.098l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC91D",
  d: "m16.652 6.04 3.094 1.133 3.14-1.15-3.094-1.134-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M19.82 4.81h-.057l-3.14 1.15v.158l3.094 1.133h.057l3.14-1.15v-.157L19.82 4.81Zm-.029.167 2.852 1.045-2.897 1.062-2.852-1.045 2.898-1.062Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD242",
  d: "M19.746 7.173v3.662l3.14-1.151V6.022l-3.14 1.151Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m22.857 5.944-3.14 1.15-.054.079v3.662l.111.078 3.14-1.15.055-.08v-3.66l-.112-.08Zm-.055.197v3.484l-2.973 1.09V7.231l2.973-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD242",
  d: "M16.638 12.008v3.662l3.14-1.15v-3.662l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m19.75 10.78-3.14 1.15-.055.079v3.661l.111.079 3.14-1.151.055-.079v-3.661l-.111-.079Zm-.055.197v3.484l-2.974 1.09v-3.484l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3775A9",
  d: "M16.638 8.31v3.662l3.14-1.15V7.16l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m19.75 7.082-3.14 1.15-.055.079v3.661l.111.079 3.14-1.15.055-.08v-3.66l-.111-.08Zm-.055.197v3.484l-2.974 1.09V8.369l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6491",
  d: "m13.544 3.479 3.095 1.134 3.14-1.15-3.095-1.135-3.14 1.151Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M16.712 2.25h-.057l-3.14 1.15v.158L16.61 4.69h.056l3.14-1.15v-.157L16.712 2.25Zm-.029.167 2.852 1.045-2.897 1.062-2.852-1.045 2.897-1.062Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3775A9",
  d: "M16.638 4.613v3.662l3.14-1.151V3.462l-3.14 1.151Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m19.75 3.384-3.14 1.15-.055.08v3.66l.111.08 3.14-1.152.055-.078V3.462l-.111-.078Zm-.055.198v3.483l-2.974 1.09V4.671l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AFAFDE",
  d: "m10.437 15.674 3.094 1.134 3.14-1.15-3.094-1.135-3.14 1.151Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M13.605 14.445h-.056l-3.14 1.15v.157l3.094 1.134h.057l3.14-1.15v-.157l-3.095-1.134Zm-.028.167 2.851 1.045-2.897 1.062-2.851-1.045 2.897-1.062Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD242",
  d: "M13.53 13.146v3.662l3.14-1.15v-3.662l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m16.642 11.917-3.14 1.15-.054.079v3.662l.111.078 3.14-1.15.055-.08v-3.66l-.112-.08Zm-.054.198v3.483l-2.974 1.09v-3.484l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3775A9",
  d: "M13.53 9.449v3.661l3.14-1.15V8.298l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m16.642 8.22-3.14 1.15-.054.079v3.661l.111.079 3.14-1.15.055-.08V8.3l-.112-.08Zm-.054.197v3.484l-2.974 1.09V9.507l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9FF",
  d: "m10.47 12 3.093 1.134v3.661l-3.094-1.134V12Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m10.497 11.921-.111.079v3.661l.054.079 3.094 1.134.112-.079v-3.661l-.055-.079-3.094-1.134Zm.055.198 2.928 1.073v3.484l-2.928-1.073v-3.484Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3775A9",
  d: "M10.423 14.284v3.662l3.14-1.15v-3.662l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m13.535 13.055-3.14 1.15-.055.08v3.66l.112.08 3.14-1.151.054-.079v-3.662l-.111-.078Zm-.055.197v3.484l-2.974 1.09v-3.484l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6491",
  d: "m7.33 13.15 3.093 1.134v3.662L7.33 16.812V13.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m7.358 13.072-.111.079v3.661l.054.079 3.094 1.133.112-.078v-3.662l-.055-.078-3.094-1.134Zm.054.198 2.929 1.073v3.483l-2.929-1.073V13.27Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6491",
  d: "m7.33 9.452 3.093 1.134 3.14-1.15-3.094-1.134-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M10.498 8.224h-.057l-3.14 1.15v.157l3.094 1.134h.057l3.14-1.15v-.158l-3.094-1.133Zm-.029.167 2.852 1.045-2.897 1.061-2.852-1.045 2.897-1.061Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3775A9",
  d: "M10.423 10.586v3.662l3.14-1.15V9.435l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m13.535 9.358-3.14 1.15-.055.079v3.661l.112.079 3.14-1.15.054-.08v-3.66l-.111-.08Zm-.055.197v3.484l-2.974 1.09v-3.484l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6491",
  d: "m7.33 9.452 3.093 1.134v3.662L7.33 13.114V9.452Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m7.358 9.374-.111.079v3.661l.054.079 3.094 1.134.112-.079v-3.662l-.055-.078-3.094-1.134Zm.054.198 2.929 1.073v3.484l-2.929-1.073V9.572Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353564",
  d: "M10.437 4.617v3.661l3.14-1.15V3.466l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m13.548 3.388-3.14 1.15-.054.079v3.661l.11.079 3.14-1.15.055-.08v-3.66l-.111-.08Zm-.055.197V7.07l-2.974 1.09V4.675l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6491",
  d: "M10.437 4.617 13.53 5.75 16.67 4.6l-3.094-1.134-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M13.605 3.388h-.056l-3.14 1.15v.157l3.094 1.134h.057l3.14-1.15V4.52l-3.095-1.133Zm-.028.167L16.428 4.6l-2.897 1.062-2.851-1.045 2.897-1.062Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3775A9",
  d: "M13.53 5.75v3.662l3.14-1.15V4.6l-3.14 1.15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m16.642 4.522-3.14 1.15-.054.079v3.662l.111.078 3.14-1.15.055-.08v-3.66l-.112-.08Zm-.054.197v3.484l-2.974 1.09V5.81l2.974-1.09Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6491",
  d: "M10.437 4.617 13.53 5.75v3.661l-3.094-1.134V4.617Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m10.465 4.539-.111.078V8.28l.054.078 3.094 1.134.111-.079V5.751l-.054-.079-3.094-1.133Zm.054.197 2.928 1.073v3.484L10.52 8.22V4.736Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.606 17.245c.333 0 .603-.19.603-.425s-.27-.425-.603-.425c-.333 0-.603.19-.603.425s.27.425.603.425ZM14.702 7.573c.333 0 .603-.19.603-.425s-.27-.425-.603-.425c-.333 0-.603.19-.603.425s.27.425.603.425Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pypi_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.031 2.25H22.97v19.5H1.031z"
})))));
export default SvgPypi;